/* eslint-disable */
/**
 * Interacción, hit testing y dibujo del canvas comparativo.
 *
 * Los métodos operan sobre la instancia de PanelLogic y no mantienen estado global.
 */
const logic = {
  getDet(ci, di) {
    this._dm = this._dm || {};
    const k = ci + '-' + di;
    if (!this._dm[k]) this._dm[k] = this.detail(ci, di);
    return this._dm[k];
  },
  draw() {
    const cv = document.querySelector('canvas[data-cmp-canvas]'),
      d = this._cmp;
    if (!cv || !d || d.mode === 'sup') return;
    const ctx = cv.getContext('2d'),
      W = cv.width,
      H = cv.height;
    ctx.clearRect(0, 0, W, H);
    const stops = [[27, 42, 90], [44, 110, 158], [63, 169, 143], [185, 201, 90], [242, 211, 92]];
    const col = (t, al = 1) => {
      t = Math.max(0, Math.min(1, t));
      const s = t * (stops.length - 1),
        i = Math.min(stops.length - 2, Math.floor(s)),
        fr = s - i,
        A = stops[i],
        B = stops[i + 1];
      return 'rgba(' + A.map((v, j) => Math.round(v + (B[j] - v) * fr)).join(',') + ',' + al + ')';
    };
    // Text uses the canvas coordinate system; CSS scales the whole canvas.
    // Viewport font units would grow again on large screens and clip labels.
    const monoFont = '13px "IBM Plex Mono", monospace',
      dateFont = '12px "IBM Plex Mono", monospace';
    ctx.font = monoFont;
    const MS = d.metrics,
      nm = MS.length,
      nd = MS[0].z.length,
      nb = MS[0].z[0].length;
    const rgba = (c, a) => 'rgba(' + c.join(',') + ',' + a + ')';
    const mix = (c, t) => {
      const bg = [16, 24, 38];
      t = Math.max(0, Math.min(1, t));
      return 'rgb(' + c.map((v, j) => Math.round(bg[j] + (v - bg[j]) * (0.12 + 0.88 * t))).join(',') + ')';
    };
    if (d.mode === 'map') {
      ctx.font = dateFont;
      const L = Math.max(70, ...d.days.map(day => Math.ceil(ctx.measureText(day).width) + 16)),
        Bm = 30,
        R = 8,
        gap = 26,
        bh = (H - Bm - gap * nm) / nm,
        cw = (W - L - R) / nb,
        ch = bh / nd;
      MS.forEach((ms, k) => {
        const top = gap * (k + 1) + bh * k;
        ctx.fillStyle = rgba(ms.rgb, 1);
        ctx.textAlign = 'left';
        ctx.textBaseline = 'bottom';
        ctx.font = '600 13px "IBM Plex Sans", sans-serif';
        ctx.fillText(ms.name, L, top - 6);
        ctx.font = dateFont;
        const fr0 = this.state.cFocus != null ? d.dIdx.indexOf(this.state.cFocus) : -1;
        ms.z.forEach((row, r) => {
          ctx.globalAlpha = fr0 >= 0 && r !== fr0 ? 0.18 : 1;
          row.forEach((v, b) => {
            ctx.fillStyle = mix(ms.rgb, v);
            ctx.fillRect(L + b * cw, top + r * ch, cw + 0.6, Math.max(1, ch - 1));
          });
        });
        ctx.globalAlpha = 1;
        if (fr0 >= 0) {
          ctx.strokeStyle = '#E8500F';
          ctx.lineWidth = 2;
          ctx.strokeRect(L - 1, top + fr0 * ch - 0.5, W - L - R + 2, ch);
        }
        if (d.selRow >= 0) {
          ctx.strokeStyle = '#e4e9f0';
          ctx.lineWidth = 1.5;
          ctx.strokeRect(L - 1, top + d.selRow * ch - 0.5, W - L - R + 2, ch);
        }
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        const every = Math.ceil(nd / Math.max(1, Math.floor(bh / 14)));
        d.days.forEach((lab, r) => {
          if ((nd - 1 - r) % every === 0 || r === d.selRow) {
            ctx.fillStyle = r === d.selRow ? '#e4e9f0' : '#8793a6';
            ctx.fillText(lab, L - 8, top + r * ch + ch / 2);
          }
        });
      });
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      ctx.fillStyle = '#8793a6';
      ctx.font = monoFont;
      d.hours.forEach(h => ctx.fillText(h.lab, Math.min(W - 30, Math.max(L + 24, L + h.f * (W - L - R))), H - Bm + 10));
      this._geo = {
        mode: 'map',
        L,
        gap,
        bh,
        cw,
        ch,
        nm
      };
      const t = this.state.cTipC;
      if (t) {
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        MS.forEach((_, k) => {
          const top = gap * (k + 1) + bh * k;
          ctx.strokeRect(L + t.b * cw, top + t.r * ch, cw, ch);
        });
      }
      return;
    }
    const yaw = this._yaw ?? -0.55,
      pitch = this._pitch ?? 0.8,
      cy = Math.cos(yaw),
      sy = Math.sin(yaw),
      sp = Math.sin(pitch),
      cp = Math.cos(pitch);
    const zm = this._zoom ?? 1,
      px = this._panX ?? 0,
      py = this._panY ?? 0;
    ctx.font = dateFont;
    const axes = MS.map((metric, k) => {
      const ticks = metric.ticks || [{ f: 0, lab: 'mín.' }, { f: 1, lab: 'máx.' }],
        labelWidth = Math.max(...ticks.map(tick => ctx.measureText(tick.lab).width));
      return { metric, ticks, labelWidth, side: k % 2 ? 1 : -1, width: Math.max(64, labelWidth + 34) };
    });
    const axisSpace = side => axes.filter(axis => axis.side === side).reduce((sum, axis) => sum + axis.width, 0),
      margin = Math.max(290, axisSpace(-1) + 32, axisSpace(1) + 32);
    const S = Math.min(Math.max(120, W - 2 * margin) * 0.72, H * 0.95) * zm;
    const P = (x, y, z) => {
      const X = x - 0.5,
        Y = y - 0.5,
        rx = X * cy - Y * sy,
        ry = X * sy + Y * cy;
      return [W / 2 + px + rx * S, H * 0.56 + py + ry * S * sp * 0.85 - z * H * 0.4 * cp * zm, ry];
    };
    const slot = nd > 1 ? 1 / Math.max(1, nd - 1) : 0.5,
      dy = Math.min(slot * 0.22, 0.035);
    const Yr = r => nd > 1 ? r / Math.max(1, nd - 1) : 0.5,
      Ym = (r, k) => Yr(r) + (k - (nm - 1) / 2) * dy;
    const poly = (pts, fill, stroke, lw) => {
      ctx.beginPath();
      pts.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
      ctx.closePath();
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
      }
      if (stroke) {
        ctx.strokeStyle = stroke;
        ctx.lineWidth = lw || 1;
        ctx.stroke();
      }
    };
    poly([[-0.02, -0.04], [1.02, -0.04], [1.02, 1.04], [-0.02, 1.04]].map(([x, y]) => P(x, y, 0)), 'rgba(4,12,24,0.7)', '#2a3446', 1);
    ctx.strokeStyle = '#1c2636';
    ctx.lineWidth = 1;
    d.hours.forEach(h => {
      const a = P(h.f, -0.04, 0),
        b = P(h.f, 1.04, 0);
      ctx.beginPath();
      ctx.moveTo(a[0], a[1]);
      ctx.lineTo(b[0], b[1]);
      ctx.stroke();
    });
    const items = [];
    for (let r = 0; r < nd; r++) for (let k = 0; k < nm; k++) items.push([r, k, P(0.5, Ym(r, k), 0)[2]]);
    items.sort((a, b) => a[2] - b[2]).forEach(([r, k]) => {
      const y = Ym(r, k),
        row = MS[k].z[r],
        c = MS[k].rgb,
        fRow = this.state.cFocus != null ? d.dIdx.indexOf(this.state.cFocus) : -1,
        dim = fRow >= 0 && r !== fRow,
        foc = fRow >= 0 && r === fRow,
        sel = !dim && (foc || r === d.selRow);
      ctx.globalAlpha = dim ? 0.12 : 1;
      const top = ms0 => ms0;
      const pts3 = MS[k].step ? row.flatMap((v, b) => {
        const x0 = b / Math.max(1, nb - 1),
          x1 = Math.min(1, (b + 1) / Math.max(1, nb - 1));
        return b === nb - 1 ? [P(x0, y, v)] : [P(x0, y, v), P(x1, y, v)];
      }) : row.map((v, b) => P(b / Math.max(1, nb - 1), y, v));
      const topPts = top(pts3);
      poly(topPts.concat([P(1, y, 0), P(0, y, 0)]), rgba(c, sel ? 0.95 : 0.72));
      ctx.beginPath();
      topPts.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
      ctx.strokeStyle = foc ? '#E8500F' : sel ? '#ffffff' : rgba(c.map(v => Math.min(255, v + 40)), 1);
      ctx.lineWidth = foc ? 2.6 : sel ? 2.2 : 1;
      ctx.stroke();
      ctx.globalAlpha = 1;
    });
    // All surfaces normalize height to 0–1. Their axes use the same projected
    // height, while labels convert it back to each metric's original units.
    const corners = [[0, 0], [1, 0], [1, 1], [0, 1]],
      edge = side => corners.reduce((best, corner) => side * P(corner[0], corner[1], 0)[0] > side * P(best[0], best[1], 0)[0] ? corner : best),
      offsets = { '-1': 16, '1': 16 };
    axes.forEach(axis => {
      const { metric, ticks, labelWidth, side } = axis,
        corner = edge(side),
        bottom = P(corner[0], corner[1], 0),
        top = P(corner[0], corner[1], 1),
        x = bottom[0] + side * offsets[side];
      offsets[side] += axis.width;
      ctx.strokeStyle = rgba(metric.rgb, 1);
      ctx.fillStyle = rgba(metric.rgb, 1);
      ctx.lineWidth = 1.5;
      ctx.font = dateFont;
      ctx.textBaseline = 'middle';
      ctx.textAlign = side < 0 ? 'right' : 'left';
      ctx.beginPath();
      ctx.moveTo(x, bottom[1]);
      ctx.lineTo(x, top[1]);
      const axisHeight = Math.abs(bottom[1] - top[1]),
        tickGap = Math.max(1, Math.ceil(18 * (ticks.length - 1) / Math.max(1, axisHeight)));
      ticks.forEach((tick, index) => {
        if (index !== 0 && index !== ticks.length - 1 && (index % tickGap !== 0 || Math.min(tick.f, 1 - tick.f) * axisHeight < 18)) return;
        const y = P(corner[0], corner[1], tick.f)[1];
        ctx.moveTo(x, y);
        ctx.lineTo(x + side * 5, y);
        ctx.fillText(tick.lab, x + side * 8, y);
      });
      ctx.stroke();
      ctx.save();
      ctx.translate(x + side * (labelWidth + 24), (bottom[1] + top[1]) / 2);
      ctx.rotate(-Math.PI / 2);
      ctx.textAlign = 'center';
      ctx.font = '600 ' + dateFont;
      ctx.fillText(metric.name, 0, 0);
      ctx.restore();
    });
    this._geo = {
      mode: '3d',
      P,
      Ym
    };
    const t = this.state.cTipC;
    if (t && MS[t.k]) {
      const top = P(t.b / Math.max(1, nb - 1), Ym(t.r, t.k), MS[t.k].z[t.r][t.b]),
        bot = P(t.b / Math.max(1, nb - 1), Ym(t.r, t.k), 0);
      ctx.strokeStyle = 'rgba(255,255,255,0.7)';
      ctx.lineWidth = 1;
      ctx.setLineDash([3, 3]);
      ctx.beginPath();
      ctx.moveTo(top[0], top[1]);
      ctx.lineTo(bot[0], bot[1]);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.beginPath();
      ctx.arc(top[0], top[1], 6, 0, Math.PI * 2);
      ctx.fillStyle = rgba(MS[t.k].rgb, 1);
      ctx.fill();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.stroke();
    }
    const ex = P(1, 0.5, 0)[0] > P(0, 0.5, 0)[0] ? 1 : 0;
    // Dates stay inside the floor edge, leaving the outer columns for scales.
    ctx.textAlign = ex > 0.5 ? 'right' : 'left';
    ctx.textBaseline = 'middle';
    const fR = this.state.cFocus != null ? d.dIdx.indexOf(this.state.cFocus) : -1;
    d.days.forEach((lab, r) => {
      if (nd <= 16 || r % 2 === (nd - 1) % 2 || r === d.selRow || r === fR) {
        const p = P(ex, Yr(r), 0);
        ctx.fillStyle = r === fR ? '#E8500F' : fR >= 0 ? 'rgba(135,147,166,0.35)' : r === d.selRow ? '#e4e9f0' : '#8793a6';
        ctx.font = (r === d.selRow ? '600 ' : '') + monoFont;
        ctx.fillText(lab, p[0] + (ex > 0.5 ? -8 : 8), p[1]);
      }
    });
    ctx.font = monoFont;
    const ye = P(0.5, 1, 0)[2] > P(0.5, 0, 0)[2] ? 1.1 : -0.1;
    ctx.textAlign = 'center';
    ctx.fillStyle = '#8793a6';
    d.hours.forEach(h => {
      const p = P(h.f, ye, 0);
      ctx.fillText(h.lab, p[0], p[1]);
    });
  }
};
export default logic;
